// @ts-strict-ignore
import { request } from '@node-space/rest-api'
import { RequestProps } from '@node-space/rest-api/lib/api'

type RequestApiProps = Omit<RequestProps, 'headers'> & {
  headers?: Record<string, string>
}

export const customHeaders: RequestApiProps['headers'] = {
  'x-requester': process.env.BASE_URL,
  'x-tag': 'merchant-portal',
}

export const requestApi = ({
  url,
  method,
  data,
  params,
  admin,
  authenticated,
  impersonate,
  debug,
  access_token,
  secret,
  baseUrl,
  fullResponse,
  bff,
  timeout,
  config,
  headers = customHeaders,
}: RequestApiProps) => {
  return request({
    url,
    method,
    data,
    params,
    headers: headers as RequestProps['headers'],
    admin,
    authenticated,
    impersonate,
    debug,
    access_token,
    secret,
    baseUrl,
    fullResponse,
    bff,
    timeout,
    config,
  })
}
